module.exports = __webpack_public_path__ + "img/expanded-icon.648c6f23.svg";